import {CheckoutRenderer} from "../checkoutRenderer";
import {CheckoutGuestsInformationForm} from "../checkoutGuestsInformationForm";
import {CheckoutOrderHandler} from "../checkoutOrderHandler";
import {CheckoutPayyoOrderHandler} from "./checkoutPayyoOrderHandler";
import {CheckoutGuestsInformationFormProvider} from "../checkoutGuestsInformationFormProvider";
import {CheckoutCollapses} from "../checkoutCollapses";

export class CheckoutPayyoRenderer extends CheckoutRenderer
{
    /**
     * Render guest information inputs and initialize payment handler object
     *
     * @override
     * @param items
     */
    renderGuestInformation(items) {

        /**
         * Render guests form
         * @type {CheckoutGuestsInformationForm}
         */
        // const form = new CheckoutGuestsInformationForm();
        const form = new CheckoutGuestsInformationFormProvider().getCheckoutGuestsInformationForm();
        form.setItems(items).setValidator(this.validator).renderForm();

        /**
         * Initialize order handler
         * @type {CheckoutOrderHandler}
         */
        const handler = new CheckoutPayyoOrderHandler();
        handler.setItems(items).setValidator(this.validator).listen();

        // form.mock();
    }

    /**
     * Render personal information-related errors
     * @todo: implement rendering here.
     * @param errors
     */
    renderPlaceOrderErrors(errors)
    {
        /**
         * Open personal info collapses and scroll to this collapse.
         * @type {CheckoutCollapses}
         */
        const collapses = new CheckoutCollapses();

        console.log('inbount errors', errors);

        collapses.openCollapse(collapses.getPersonalInfoCollapse());
        collapses.scrollToCollapse(collapses.getPersonalInfoCollapse());

    }


    /**
     * Add loading overlay to all screen
     */
    screenLoading()
    {

    }
}